import {doc} from '../docs.js';

doc(
    'list.fillIndex',
    {
        'size': ""
    },
    'Creates a list of size n with elements from 0...n'
);

export const indexFill = () => {
    return ([msg]) => {
        let l=[];
        for (let i=0; i < msg; i++) {
            l.push(i);
        }
        return [l];
    };
};

export const listGenerators = {
    'list.fillIndex': indexFill
};
